import { render, staticRenderFns } from "./EventLastWinPage.vue?vue&type=template&id=aca12962&scoped=true&"
import script from "./EventLastWinPage.vue?vue&type=script&lang=js&"
export * from "./EventLastWinPage.vue?vue&type=script&lang=js&"
import style0 from "./EventLastWinPage.vue?vue&type=style&index=0&id=aca12962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca12962",
  null
  
)

export default component.exports